/* eslint-disable n/no-callback-literal */
import PusherJS from 'pusher-js'
import React, { Suspense, type ReactElement, useContext } from 'react'
import QRCode from 'react-qr-code'
import { RoomSettingsContext } from '../pages/+RoomSettingsContext'
import { Box, Flex, Heading, Text } from '@chakra-ui/react'
const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWEXYZ'

const badWords = [
  'anus',
  'arse',
  'butt',
  'clit',
  'cock',
  'coon',
  'cunt',
  'dago',
  'damn',
  'dick',
  'dike',
  'dyke',
  'fuck',
  'gook',
  'heeb',
  'hell',
  'homo',
  'jizz',
  'kike',
  'kunt',
  'kyke',
  'mick',
  'muff',
  'nazi',
  'paki',
  'piss',
  'poon',
  'puto',
  'shit',
  'shiz',
  'slut',
  'smeg',
  'spic',
  'tard',
  'tits',
  'twat',
  'twit',
  'wank'
]

const createRoom = (
  client: PusherJS,
  name: string,
  callback: any,
  actions: any,
  attempts: number,
  lobby: boolean = false,
  version: string = '',
  prevRoomCode?: string | undefined
): void => {
  if (attempts >= 2) {
    callback(false)
  } else {
    let newRoomCode: string
    if (prevRoomCode === undefined) {
      do {
        newRoomCode =
          alphabet[Math.floor(Math.random() * alphabet.length)] +
          alphabet[Math.floor(Math.random() * alphabet.length)] +
          alphabet[Math.floor(Math.random() * alphabet.length)] +
          alphabet[Math.floor(Math.random() * alphabet.length)] +
          version
        console.log(newRoomCode)
      } while (badWords.includes(newRoomCode.toLowerCase()))
    } else {
      newRoomCode = prevRoomCode
    }

    if (lobby) {
      const tempLobbyChannel: any = client.subscribe(
        'presence-' + newRoomCode + '-lobby'
      )

      tempLobbyChannel.bind('pusher:subscription_succeeded', function () {
        if (tempLobbyChannel.members.count > 1 && prevRoomCode === undefined) {
          client.unsubscribe('presence-' + newRoomCode + '-game')
          client.unsubscribe('presence-' + newRoomCode + '-lobby')

          createRoom(
            client,
            name,
            callback,
            actions,
            attempts + 1,
            lobby,
            version,
            prevRoomCode
          )
        } else {
          const tempChannel: any = client.subscribe(
            'presence-' + newRoomCode + '-game'
          )

          tempChannel.bind('pusher:subscription_succeeded', function () {
            if (tempChannel.members.count > 1) {
              client.unsubscribe('presence-' + newRoomCode + '-game')
              client.unsubscribe('presence-' + newRoomCode + '-lobby')

              createRoom(client, name, callback, actions, attempts + 1, lobby)
            } else {
              tempLobbyChannel.bind('pusher:member_added', (message: any) => {
                actions.triggerLobbyEnter(message, tempLobbyChannel)
              })
              tempLobbyChannel.bind('client-message_sent', (message: any) => {
                actions.triggerAction(message, tempLobbyChannel)
              })
              tempChannel.bind('pusher:member_added', (message: any) => {
                actions.triggerEnter(message, tempChannel)
              })
              tempChannel.bind('client-message_sent', (message: any) => {
                actions.triggerAction(message, tempChannel)
              })

              callback({
                roomCode: newRoomCode,
                channel: tempChannel,
                lobbyChannel: tempLobbyChannel,
                client
              })
            }
          })
        }
      })
    } else {
      const tempChannel: any = client.subscribe('presence-' + newRoomCode)

      tempChannel.bind('pusher:subscription_succeeded', function () {
        if (tempChannel.members.count > 1) {
          client.unsubscribe('presence-' + newRoomCode)
          createRoom(
            client,
            name,
            callback,
            actions,
            attempts + 1,
            lobby,
            version
          )
        } else {
          tempChannel.bind('pusher:member_added', (message: any) => {
            actions.triggerEnter(message, tempChannel)
          })
          tempChannel.bind('client-message_sent', (message: any) => {
            actions.triggerAction(message, tempChannel)
          })

          callback({ roomCode: newRoomCode, channel: tempChannel, client })
        }
      })
    }
  }
}
PusherJS.log = function (msg) {
  if (msg.indexOf('trash') === -1) {
    console.log(msg)
  }
}

const connection = (
  name: string,
  callback: any,
  actions: any,
  lobby: boolean = false,
  version: string = '',
  prevRoomCode?: string | undefined
): void => {
  const client = new PusherJS(import.meta.env.PUBLIC_ENV__SOKETI_KEY, {
    wsHost: 'reactvts.com',
    wssPort: 6001,
    forceTLS: true,
    cluster: 'soketi',
    userAuthentication: {
      endpoint: 'https://reactvts.com:3030/pusher/user-auth',
      transport: 'ajax'
    },
    channelAuthorization: {
      endpoint: 'https://reactvts.com:3030/pusher/auth',
      transport: 'ajax',
      params: {
        userType: 'room',
        name: 'server-' + name
      }
    },
    disableStats: true,
    enabledTransports: ['ws', 'wss']
  })
  createRoom(client, name, callback, actions, 0, lobby, version, prevRoomCode)
}
const RoomCode = ({
  roomCode,
  hide = false,
  left = false
}: {
  roomCode: string | undefined
  hide?: boolean
  left?: boolean
}): ReactElement => {
  const { roomSettings } = useContext(RoomSettingsContext)
  const styles = {
    box: {
      position: 'fixed',
      bottom: '15px',
      right: left ? 'auto' : '15px',
      left: left ? '15px' : 'auto',
      fontSize: '75px',
      color: 'black',
      zIndex: 10,
      border: '10px solid',
      borderColor: 'yellow.300',
      backgroundColor: 'yellow.300',
      'path:nth-of-type(1)': {
        display: 'none'
      }
    },
    qrCodeBoth: {
      bottom: '1.25em'
    }
  }
  if (
    roomSettings !== null &&
    roomSettings.options.hideRoomCode.value === false &&
    !hide
  ) {
    switch (roomSettings.options.roomCodeType.value) {
      case 'text':
        return (
          <Flex
            aspectRatio="1"
            flexDir={'column'}
            justifyContent={'center'}
            sx={{ ...styles.box }}
            boxShadow="sm"
          >
            <Text
              fontSize={{ base: '12px', xl: '16px', '2xl': '26px' }}
              lineHeight="0.9"
              fontWeight="800"
              letterSpacing="-0.025em"
              textAlign="center"
              pb="0.0em"
              mb="0"
              px={{ base: '5px', lg: '10px', '2xl': '20px' }}
            >
              Reactvts.com/join <br />
              <br />
              Room Code:
            </Text>
            <Heading
              as="p"
              textAlign="center"
              sx={{
                fontSize: { base: '43px', xl: '60px', '2xl': '85px' },
                lineHeight: 0.8,
                letterSpacing: '-0.1em',
                color: 'gray.700',
                zIndex: 1000,
                mb: 0
              }}
              px={{ base: '5px', lg: '10px', '2xl': '20px' }}
            >
              {roomCode ?? ''}
            </Heading>
          </Flex>
        )
      case 'bizhawk':
        return (
          <Flex
            aspectRatio="1"
            flexDir={'column'}
            justifyContent={'center'}
            sx={{ ...styles.box }}
            boxShadow="sm"
          >
            <Text
              fontSize={{ base: '16px', '2xl': '26px' }}
              lineHeight="1.2"
              fontWeight="800"
              letterSpacing="-0.025em"
              textAlign="center"
              pb="0em"
              mb="0"
              px={{ base: '5px', lg: '10px', '2xl': '20px' }}
            >
              Setup Instruction at <br />
              Reactvts.com/join-va <br />
              <br />
              Room code:
            </Text>
            <Heading
              as="p"
              textAlign="center"
              sx={{
                fontSize: { base: '32px', '2xl': '85px' },
                lineHeight: 0.8,
                letterSpacing: '-0.1em',
                color: 'gray.700',
                zIndex: 1000,
                mb: 0
              }}
              px={{ base: '5px', lg: '10px', '2xl': '20px' }}
            >
              {roomCode ?? ''}
            </Heading>
          </Flex>
        )
      case 'qrCode':
      default:
        return (
          <Box sx={styles.box} boxShadow="md">
            <Heading
              textAlign="center"
              fontWeight="800"
              lineHeight="1.1"
              mb="1.5"
              fontSize="26px"
            >
              Scan&nbsp;to Join
            </Heading>
            {typeof roomCode !== 'undefined' && (
              <Suspense fallback={<div>Loading QR Code...</div>}>
                <QRCode
                  fgColor="#2d3748"
                  bgColor="transparent"
                  size={200}
                  value={`http://reactvts.com/join?room-code=${roomCode ?? ''}`}
                />
              </Suspense>
            )}
            <Heading
              textAlign="center"
              fontWeight="800"
              lineHeight="1.1"
              mt="1.5"
              mb="0"
              fontSize={{ base: '5px', xl: '20px' }}
            >
              Room Code: {roomCode ?? ''}
            </Heading>
          </Box>
        )
    }
  } else {
    return <Box></Box>
  }
}

export { connection, RoomCode }
